"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.randomString = randomString;
var _isInteger = _interopRequireDefault(require("lodash/isInteger"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function randomString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
  if (!(0, _isInteger["default"])(length)) {
    throw new Error("Invalid input '".concat(length, "', please provide a number"));
  }
  var str = '';
  while (str.length < length) {
    str += Math.round(Math.random() * 2147483647).toString(36);
  }
  return str.substr(0, length);
}